export default __webpack_public_path__ + "static/media/ticket.dcbfa224.svg";